import {ACTION_TYPES} from "../../../../../core/consts";
import {MatchEventsModuleController} from "../match-events-module.controller";
import {MatchEventModuleTabClickAnalyticsEvent} from "../models/match-event-module.tab-click.analytics-event";
import {AnalyticsEventHandler} from "../../../../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../../../../third-party-services/analytics/analytics-service";
import {MatchEventsModuleState} from "../models/match-events-module.state";

export class MatchEventsModuleChangeTabHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.tabChange;
  analyticsService: AnalyticsService;
  state: MatchEventsModuleState;
  controller: MatchEventsModuleController;

  static injectables = [AnalyticsService];

  onUnloaded() {
    super.onUnloaded();

    this.changeTabSelectedIndex()
  }

  async action(params) {
    this.changeTabSelectedIndex(params.index)

    this.sendAnalyticsEvent();
  }

  changeTabSelectedIndex(index) {
    this.store.selectMatchEventTabByIndex(index);
  }


  sendAnalyticsEvent() {
    const sendParams = {
      gameId: this.controller.props.gameId,
      status: this.state.gameStatus,
      tab: this.state.activeTab.type
    }

    const clickEvent: MatchEventModuleTabClickAnalyticsEvent = new MatchEventModuleTabClickAnalyticsEvent(sendParams);

    this.analyticsService.createEvent(clickEvent);
  }
}
